import { I18n } from '@app/shared/enums/i18n.enum';

export const environment = {
  production: true,
  apiVersion: 1,
  domain: 'wejoiner.com',
  toasterTimeOut: 10000,
  copyTextTimeOut: 2000,
  chatPaginationTimeOut: 3000,
  notFoundTimeOut: 1000,
  beginPageSliderTimeOut: 200,
  baseUrl: {
    base: 'https://api.wejoiner.com',
    main: 'https://api.wejoiner.com',
    um: 'https://api.wejoiner.com/um',
    socket: 'https://api.wejoiner.com',
    messenger: 'https://api.wejoiner.com/messenger',
    uploadFile: 'https://api.wejoiner.com/files',
    file: 'https://api.wejoiner.com',
    panelUrl: 'https://panel.wejoiner.com',
  },
  auth: {
    url: 'https://auth.wejoiner.com',
    realm: 'wejoiner',
    clientId: 'website-wejoiner',
    clientUniqueId: '5b44717c-fee3-4d8e-a031-4c8666a605ae',
    apiId: 'api-wejoiner',
  },
  firebase: {
    apiKey: 'AIzaSyAAshQQrk-8ZQCavmy9uPqVHK3lShDXW7E',
    authDomain: 'agbk-prod.firebaseapp.com',
    projectId: 'agbk-prod',
    storageBucket: 'agbk-prod.appspot.com',
    messagingSenderId: '298961683722',
    appId: '1:298961683722:web:4b013dee1df4305a6726f3',
    vapidKey:
      'BCThKVnv2HJzCFmE0vuNZsyKS1W1FZ0uKE3nUdv0q5X60lyJ-HLTtjuEwn2A312R_5BN3G8HH22NMnYTrd5bOLc',
  },
  defaultLang: I18n.en,
  userManagementUrl: 'https://um.wejoiner.com/',
  mapApiKey: 'AIzaSyC7A3VZ8sisBhtlspIINS8AHkDNZ3npvyg',
  recaptcha: {
    siteKey: '6LdpKW4qAAAAALnc2ph1Bb15dyPW5IR86XW-yLTp',
    targetScore: 0.7,
  },
  googleAnalytics: 'G-115Z6CXS64',
  gtmId: 'GTM-T5CB6BTF',
  matomoEnabled: false,
  matomoSiteId: 2,
  matomoTrackerUrl: 'https://wejoiner.matomo.cloud',
  matomoScriptUrl: 'https://cdn.matomo.cloud/wejoiner.matomo.cloud/matomo.js',
};
